<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<!-- Modern Tab Switch Bar -->
<div class="voucher-auth-container">
    <div class="tab-switch-wrapper mb-3">
        <div class="custom-tab-bar">
            <button type="button" class="tab-btn" [class.active]="activeTab === 'individual'" (click)="selectTab('individual')">
                <i class="fas fa-file-invoice mr-2"></i>
                <span class="tab-title">Individual</span>
            </button>
            <button type="button" class="tab-btn" [class.active]="activeTab === 'batch'" (click)="selectTab('batch')">
                <i class="fas fa-layer-group mr-2"></i>
                <span class="tab-title">Batch Wise</span>
            </button>
        </div>
    </div>

    <!-- ==================== INDIVIDUAL TAB ==================== -->
    <div [hidden]="activeTab !== 'individual'" class="tab-content-pane">
        <div class="row m-0 col-md-12 p-0 formborder">
            <form #df="ngForm" novalidate (keydown.enter)="onSearchPendingAuth()" class="w-100">
                <div class="row align-items-center m-0 px-3 py-2">
                    <div class="col-custom-5 mb-2">
                        <span>Voucher Date From</span>
                        <div class="datepicker_feild">
                            <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="VoucherDateFrom"
                                id="VoucherDateFrom" [min]="minDate" (dateChange)="DateChange()"
                                [max]="maxDate" class="form-control input-text-css"
                                [(ngModel)]="StartDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Date To</span>
                        <div class="datepicker_feild">
                            <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="VoucherDateTo"
                                id="VoucherDateTo" [min]="minDate" (dateChange)="DateChange()"
                                [max]="maxDate"
                                class="form-control input-text-css" [(ngModel)]="EndDate" />
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Type</span>
                        <select name="VoucherType" id="VoucherType" class="form-control input-text-css"
                            [(ngModel)]="VoucherType">
                            <option value="">Select Voucher Type</option>
                            <option value="Receipt">Receipt</option>
                            <option value="Payment">Payment</option>
                            <option value="Journal">Journal</option>
                            <option value="Contra">Contra</option>
                            <option value="Disbursement">Disbursement </option>
                            <!-- <option value="Reschedule">Reschedule</option> -->
                            <option value="WriteOff">WriteOff</option>
                            <option value="Closer">Closure</option>
                            <!-- <option value="Repossessed">Repossessed</option> -->
                            <option value="Settled">Settled</option>
                            <option value="Repayment">Repayment</option>
                        </select>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Voucher Subtype</span>
                        <select name="VoucherSubType" id="VoucherSubType" class="form-control input-text-css"
                            [(ngModel)]="VoucherSubType">
                            <option value="">Select Voucher Subtype</option>
                            <option value="Loan">Loan</option>
                            <option value="Accounting">Accounting</option>
                            <option value="Partner">Partner</option>
                        </select>
                    </div>
                    <div class="col-custom-5 mb-2">
                        <span>Status</span>
                        <select name="Status" id="Status" class="form-control input-text-css" [(ngModel)]="Status">
                            <option value="">Select Status</option>
                            <option value="Created">Created</option>
                            <option value="Modified">Modified</option>
                            <option value="Deleted">Deleted</option>
                        </select>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Amount From</span>
                        <div class="datepicker_feild">
                            <input type="number" name="AmountFrom" id="AmountFrom" class="form-control input-text-css"
                                [(ngModel)]="AmountFrom" placeholder="Amount From" />
                        </div>
                    </div>

                    <div class="col-custom-5 mb-2">
                        <span>Amount To</span>
                        <div class="datepicker_feild">
                            <input type="number" name="AmountTo" id="AmountTo" class="form-control input-text-css"
                                [(ngModel)]="AmountTo" placeholder="Amount To" />
                        </div>
                    </div>

                    <div class="col-custom-search mb-2 d-flex align-items-center" style="align-self: flex-end; gap: 10px;">
                        <button type="button" (click)="onSearchPendingAuth()" class="btn font-size-12 button-btn" style="white-space: nowrap;">
                            <i class="fa fa-search mr-1"></i> Search
                        </button>

                        <div class="flex-grow-1" *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">
                            <form action="" class="search-text m-0 w-100">
                                <div class="bg-light rounded rounded-pill shadow-sm">
                                    <div class="input-group">
                                        <input type="text" id="FilterInputSearch" (keyup)="applyFilter($any($event.target).value)"
                                            name="FilterInputSearch" placeholder="What're you searching for?"
                                            class="form-control border-0 bg-light" style="font-size: 11px; height: 32px;" />
                                        <div class="input-group-append">
                                            <button id="button-addon1" type="submit" class="btn btn-link text-primary p-0 pr-2">
                                                <i class="fa fa-search" style="font-size: 11px;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="mt-3" *ngIf="dataSource">
            <div class="">
                <div class="table-responsive">
                    <mat-table [dataSource]="dataSource" matSort #sort="matSort" matTableExporter #exporter="matTableExporter"
                        style="max-width: 100%; overflow: auto">

                        <ng-container matColumnDef="Voucher_No">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher No
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_No }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Status">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher Status
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Status }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Type">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Voucher
                                Type</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Type }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Date">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                                Voucher Date
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Date }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_CreateOn">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Create On</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_CreateOn }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Voucher_Sub_Type">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Voucher Sub
                                Type</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Voucher_Sub_Type }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Amount">
                            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Amount</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="grid-cell">
                                {{ row.Amount }}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Action">
                            <mat-header-cell class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                                <app-lms-voucher-accounts-view-model [voucherid]="row.VoucherId" [index]="i" [ROW]="row" (close)="onViewModalClose($event)" [VoucherFrom]="'UnauthorizedVouchers'">
                                    <i class="fas fa-eye"></i>
                                </app-lms-voucher-accounts-view-model>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumnsModel; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnsModel"></mat-row>
                    </mat-table>

                    <div class="row m-0 pt-2 pb-1">
                        <div class="col-md-2">
                            <button class="mt-3 btn font-size-12 button-btn" (click)="exportPendingAuthTable(exporter)">
                                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                                Export
                            </button>
                        </div>
                        <div class="col-md-6 mt-3">
                            <mat-paginator #paginator [pageSizeOptions]="[20, 50]" showFirstLastButtons>
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ==================== BATCH WISE TAB ==================== -->
    <div [hidden]="activeTab !== 'batch'" class="tab-content-pane">
        <div class="row m-0 col-md-12 p-0 formborder">
            <div class="row align-items-center m-0 px-3 py-2 w-100">
                <div class="col-md-3 text-left mb-2">
                    <button type="button" (click)="onSearchBatch()" class="btn font-size-12 button-btn">
                        <i class="fa fa-sync mr-1"></i> Refresh Batches
                    </button>
                </div>

                <div class="col-md-4">
                    <form action="" class="search-text">
                        <div class="bg-light rounded rounded-pill shadow-sm">
                            <div class="input-group">
                                <input type="text" id="FilterBatchSearch" (keyup)="applyBatchFilter($any($event.target).value)"
                                    name="FilterBatchSearch" placeholder="What're you searching for?"
                                    class="form-control border-0 bg-light" />
                                <div class="input-group-append">
                                    <button id="button-addon-batch" type="submit" class="btn btn-link text-primary">
                                        <i class="fa fa-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="mt-3" *ngIf="batchDataSource">
            <div class="table-responsive">
                <mat-table [dataSource]="batchDataSource" matSort #batchSort="matSort" style="max-width: 100%; overflow: auto">
                    <!-- Sr No Column (Left Aligned) -->
                    <ng-container matColumnDef="SrNo">
                        <mat-header-cell class="grid-header" *matHeaderCellDef> # </mat-header-cell>
                        <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                            {{ (batchPaginator?.pageIndex * batchPaginator?.pageSize) + (i + 1) }}
                        </mat-cell>
                    </ng-container>

                    <!-- Batch No Column (Centered) -->
                    <ng-container matColumnDef="Batch_no">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Batch No </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center fw-600"> {{ row.Batch_no }} </mat-cell>
                    </ng-container>

                    <!-- Created By Column (Centered) -->
                    <ng-container matColumnDef="Voucher_CreateBy">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Created By </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center"> {{ row.Voucher_CreateBy }} </mat-cell>
                    </ng-container>

                    <!-- Voucher Count Column (Centered) -->
                    <ng-container matColumnDef="VoucherIdCount">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Voucher Count </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center">
                            <span class="badge-count-pill">{{ row.VoucherIdCount }}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Created On Column (Centered) -->
                    <ng-container matColumnDef="Voucher_CreateOn">
                        <mat-header-cell mat-sort-header class="grid-header text-center" *matHeaderCellDef> Created On </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center"> {{ row.Voucher_CreateOn }} </mat-cell>
                    </ng-container>

                    <!-- Action / Detail Column (Centered) -->
                    <ng-container matColumnDef="Action">
                        <mat-header-cell class="grid-header text-center" *matHeaderCellDef> Detail </mat-header-cell>
                        <mat-cell *matCellDef="let row" class="grid-cell text-center">
                            <span class="cursor-pointer text-primary" (click)="onViewBatchDetail(row)" title="View Batch Detail" style="cursor: pointer; font-size: 15px;">
                                <i class="fas fa-eye"></i>
                            </span>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="batchDisplayedColumns; sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: batchDisplayedColumns"></mat-row>
                </mat-table>

                <mat-paginator #batchPaginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>

<!-- ==================== BATCH VOUCHER DETAILS MODAL ==================== -->
<div class="modal fade in" id="BatchVoucherDetailsModal" tabindex="-1" role="dialog" aria-labelledby="batchDetailModalLabel"
    data-backdrop="false" style="background-color: rgba(15, 23, 42, 0.55); overflow: auto; z-index: 9999 !important;">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content voucher-modal-content" id="BatchVoucherDetailPrint">

            <!-- Modal Header -->
            <div cdkDragHandle class="modal-header voucher-modal-header">
                <h6 class="modal-title" id="batchDetailModalLabel">
                    <i class="far fa-file-alt mr-2"></i> Batch Voucher Detail
                </h6>
                <button type="button" (click)="onCloseBatchDetailsModal()" class="close voucher-close-btn d-print-none" aria-label="Close">
                    <span aria-hidden="true"><i class="far fa-times-circle"></i></span>
                </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body voucher-modal-body">
                <!-- Voucher Type Banner -->
                <div class="row m-0 text-left">
                    <div class="col-md-12 voucher-type-banner">
                        <span class="voucher-type-label">Voucher Type</span>
                        <span class="voucher-type-value">
                            {{ batchSummaryHeader?.Voucher_Type || 'Repayment' }} —
                            {{ batchSummaryHeader?.Voucher_Sub_Type || 'Loan' }}
                        </span>
                    </div>
                </div>

                <!-- Meta Info Cards -->
                <div class="row m-0 mt-2 voucher-meta-row">
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Batch No</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_No || batchSummaryHeader?.Batch_no || '-' }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Created By</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_CreateBy || '-' }}</span>
                        </div>
                    </div>
                    <div class="col-md-4 p-2">
                        <div class="voucher-meta-card text-center">
                            <span class="meta-label">Created On</span>
                            <span class="meta-value">{{ batchSummaryHeader?.Voucher_Date || batchSummaryHeader?.Voucher_CreateOn || '-' }}</span>
                        </div>
                    </div>
                </div>

                <!-- Voucher Details Table -->
                <div class="row m-0 mt-3">
                    <div class="col-md-12 p-0">
                        <div class="voucher-table-wrapper">
                            <table class="table table-bordered voucher-table">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">#</th>
                                        <th class="text-center" style="width: 100px;">Dr/Cr</th>
                                        <th class="text-center" style="width: 140px;">LAN</th>
                                        <th class="text-center">Customer</th>
                                        <th class="text-center" style="width: 140px;">Branch</th>
                                        <th class="text-center">Charge Head</th>
                                        <th class="text-center">Party Name / Ledger</th>
                                        <th class="text-center" style="width: 110px;">Date</th>
                                        <th class="text-center" style="width: 120px;">Amount DR</th>
                                        <th class="text-center" style="width: 120px;">Amount CR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of batchVoucherDetailsList; let idx = index"
                                        [ngClass]="item.groupClass">
                                        <td class="text-center fw-600" [class.fw-700]="item.isGroupTotal">
                                            {{ item.isGroupTotal ? '' : (idx + 1) }}
                                        </td>
                                        <td class="text-center">
                                            <span *ngIf="!item.isGroupTotal && item.TranType"
                                                class="type-badge"
                                                [ngClass]="item.TranType === 'DR' ? 'badge-dr' : 'badge-cr'">
                                                {{ item.TranType }}
                                            </span>
                                        </td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.CaseNo }}</td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.Customer }}</td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.Branch_Name }}</td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.ChagesHead }}</td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.Account_Name }}</td>
                                        <td class="text-center" [class.fw-700]="item.isGroupTotal">{{ item.Voucher_Date || '-' }}</td>
                                        <td class="text-center amount-dr" [class.fw-700]="item.isGroupTotal">
                                            {{ item.AmountDR > 0 ? (item.AmountDR | number:'1.2-2') : '-' }}
                                        </td>
                                        <td class="text-center amount-cr" [class.fw-700]="item.isGroupTotal">
                                            {{ item.AmountCR > 0 ? (item.AmountCR | number:'1.2-2') : '-' }}
                                        </td>
                                    </tr>
                                    <tr *ngIf="!batchVoucherDetailsList || batchVoucherDetailsList.length === 0">
                                        <td colspan="10" class="text-center py-4 text-muted">
                                            <i class="fa fa-info-circle mr-1"></i> No voucher details found for this batch.
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot *ngIf="batchVoucherDetailsList && batchVoucherDetailsList.length > 0">
                                    <tr class="voucher-total-row fw-700">
                                        <td colspan="8" class="text-center">Grand Total</td>
                                        <td class="text-center amount-dr">{{ calculateBatchTotalDR() | number:'1.2-2' }}</td>
                                        <td class="text-center amount-cr">{{ calculateBatchTotalCR() | number:'1.2-2' }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Footer Narration & Meta -->
                <div class="row m-0 mt-3 pt-2 voucher-footer-info" *ngIf="batchSummaryHeader?.Voucher_Narration || batchSummaryHeader?.Narration">
                    <div class="col-md-12 p-0">
                        <div class="voucher-divider"></div>
                        <span class="section-label">Narration</span>
                        <p class="section-value">{{ batchSummaryHeader?.Voucher_Narration || batchSummaryHeader?.Narration }}</p>
                    </div>
                </div>
            </div>

            <!-- Modal Footer (Action Controls & Remark) -->
            <div class="modal-footer voucher-modal-footer no-print d-print-none flex-column align-items-stretch">
                <div class="row m-0 w-100 mb-2 text-left">
                    <div class="col-md-12 p-0">
                        <h6 class="section-label mb-1">Remark <span class="text-danger">*</span></h6>
                        <input type="text" class="form-control font-size-12" [(ngModel)]="batchActionRemark" name="batchActionRemark"
                            placeholder="Enter Remark for Deleting Batch" />
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex">
                        <button type="button" class="btn btn-danger font-size-12" (click)="onBatchDeleteFromDetail()"
                            [class.spinner]="showSpinner">
                            <i class="fas fa-trash-alt mr-1"></i> Delete Batch
                        </button>
                    </div>
                    <div>
                        <button type="button" class="btn voucher-btn voucher-btn-primary mr-2" (click)="PrintBatchDoc('BatchVoucherDetailPrint', 'Voucher Detail')">
                            <i class="fas fa-print mr-1"></i> Print View
                        </button>
                        <button type="button" class="btn btn-secondary font-size-12" (click)="onCloseBatchDetailsModal()">
                            Close
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>